export const domain = 'le-palais-blocks';
export const category = 'le-palais';
export const categorySection = 'le-palais-section';
export const defaultGap = '1rem';
export const defaultOuterBlocks = [
	'core/group',
	'core/query',
	'core/column',
	'core/post-content',
];
export const tablet = 600;
export const large = 1200;
export const bpHeader = 1050;
